let bootstrapError: unknown = null

export function setBootstrapError(error: unknown) {
  bootstrapError = error
}

export function getBootstrapError() {
  return bootstrapError
}
